import React, { FormEvent, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { useSuperAdminAuth } from '../../contexts/SuperAdminAuthContext';
import './SuperAdminAuth.scss';

const SuperAdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useSuperAdminAuth();

  useEffect(() => {
    void import('./superAdminPages.lazy');
    void import(/* webpackChunkName: "super-admin-catalog" */ './SuperAdminTemplates');
  }, []);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [formErrors, setFormErrors] = useState({
    email: '',
    password: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: '' }));
    if (error) {
      clearError();
    }
  };

  const validateForm = () => {
    const nextErrors = {
      email: '',
      password: '',
    };

    if (!formData.email) {
      nextErrors.email = 'L’email est obligatoire';
    }

    if (!formData.password) {
      nextErrors.password = 'Le mot de passe est obligatoire';
    }

    setFormErrors(nextErrors);
    return !nextErrors.email && !nextErrors.password;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    try {
      await login(formData);
      navigate('/super-admin/dashboard', { replace: true });
    } catch {
      // handled in context
    }
  };

  return (
    <div className="super-admin-auth">
      <div className="super-admin-auth__card">
        <p className="super-admin-auth__eyebrow">ZEEDCOM Control</p>
        <h1 className="super-admin-auth__title">Connexion super-admin</h1>

        {error && <div className="super-admin-auth__alert super-admin-auth__alert--error">{error}</div>}

        <form className="super-admin-auth__form" onSubmit={handleSubmit}>
          <Input
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            error={formErrors.email}
            placeholder="admin@zeedcom.com"
            required
            fullWidth
            autoComplete="email"
          />

          <Input
            label="Mot de passe"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            error={formErrors.password}
            placeholder="Votre mot de passe"
            required
            fullWidth
            autoComplete="current-password"
          />

          <div className="super-admin-auth__actions">
            <Button type="submit" variant="primary" size="large" fullWidth loading={isLoading}>
              Se connecter
            </Button>
          </div>
        </form>

        <div className="super-admin-auth__footer">
          <Link to="/super-admin/forgot-password">Mot de passe oublié ?</Link>
          {' · '}
          Interface marchand : <Link to="/login">connexion</Link>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
